import { Component, Input, OnChanges } from '@angular/core';
import { BarChartCustomAttributes } from '@ddt-web/chart';
import { TabViewCategory } from '@ddt-web/config';
import { ComponentData, CustomChartUtil, PortfolioDataUtil, TabData } from '@ddt-web/data-service';
import { Memoize, StringUtil } from '@ddt-web/generic-utils';
import * as get from 'lodash/get';

@Component({
	selector: 'aa-asset-allocation',
	templateUrl: './asset-allocation.component.html',
	styleUrls: ['./asset-allocation.component.scss']
})
export class AssetAllocationComponent implements OnChanges {
	@Input() public data: ComponentData;

	public asOfDate: string;
	public benchmarkPortfolioName: string = '';
	public readonly tabViewCategory: any = TabViewCategory;
	public tabsData: Array<TabData>;

	// Custom attributes are used for center-aligned bar charts
	public benchmarkCustomChartAttributes: BarChartCustomAttributes = {
		tickPositions: [-1, 0, 1],
		autoTickPositions: true,
		numberOfTicks: 2
	};
	public portfolioCustomChartAttribute: BarChartCustomAttributes;
	public StringUtil = StringUtil; // for use in HTML

	public ngOnChanges(): void {

		if (this.data.success) {
			const portfolioData = get(this.data, 'portfolioData', []);
			this.asOfDate = get(this.data, 'portfolioData[0].field.asOfDate.formattedValue', '');
			this.benchmarkPortfolioName = PortfolioDataUtil.getBenchmarkPortfolioName(portfolioData);
			this.portfolioCustomChartAttribute = { contributionTooltipTabData: this.data.getTabById('exposures.assetAllocation.contributions') };
			this.tabsData = this.data?.tabs || [];
			this.portfolioCustomChartAttribute = {
				...this.portfolioCustomChartAttribute,
				chart: {
					events: {
						load: function () {
							CustomChartUtil.updateAxisBounds(this);
						}
					}
				},
				plotOptions: {
					column: {
						stacking: 'normal'
					}
				}
			};
		}
	}

	@Memoize()
	public getTabCategory(tab): string {
		const tabCategory = StringUtil.replaceAll(tab.config.id, '.', '_').toUpperCase() + '_TAB';
		return tabCategory;
	}
}
